export default {
  title: 'Lieferadresse',
  buttons: {
    save: 'Speichern',
  },
};
